<template>
    <primary-button
        :bind-props="bindProps"
        :loading="loading"
        :disabled="disabled"
        @click="$emit('click', $event)"
    >
        <v-icon v-if="icon" left>
            {{ icon }}
        </v-icon>
        <slot/>
    </primary-button>
</template>

<script>
export default {
    name: "ActionButtonSecondaryVue",
    props: {
        bindProps: {
            type: Object,
            default: () => ({
                outlined: true
            })
        },
        icon: {
            type: String,
            default: "mdi-plus"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>
